export default __webpack_public_path__ + "static/media/logo.a4ca8dc2.webp";